import { Component, TemplateRef, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { RegistrationDialogComponent } from 'src/app/shared-module/components/registration-dialog/registration-dialog.component';
import { AuthService } from '../../services/auth.service';
@Component({
  selector: 'app-registration-form',
  templateUrl: './registration-form.component.html',
  styleUrls: ['./registration-form.component.scss']
})
export class RegistrationFormComponent implements OnInit {
  // inputDataList: any;
  heading = [{ title: 'Basic Details', subTitle: 'Please provide the following details to continue' }]
  inputDataList = [
    [
      {
        label: "Hospital Registration Number (Optional)",
        type: "text",
        controllerName: "hospital_reg_num",
        required: false,
        valueType: "string",
        hide: false,
        placeholder: "Enter Hospital Registration Number",
        errorMsg: 'hospital registration number',
      },
      {
        label: "Facility Name",
        type: "text",
        controllerName: "facility_name",
        required: true,
        valueType: "text",
        hide: false,
        placeholder: "Enter Facility Name",
        errorMsg: 'facility name',
      },
      {
        label: "Email",
        type: "email",
        controllerName: "email",
        required: true,
        valueType: "string",
        hide: false,
        placeholder: "Enter Email",
        errorMsg: 'email address',
      },

      {
        label: "OTP Verification",
        type: "number",
        required: true,
        controllerName: "otp",
        valueType: 'number',
        hide: false,
        errorMsg: 'OTP',
      },
      // {
      //   label: "Phone Number (Optional)",
      //   type: "number",
      //   controllerName: "mobile",
      //   required: false,
      //   hide: false,
      //   valueType: 'number',
      //   placeholder: "Enter Phone Number",
      //   errorMsg: 'phone number',
      // },
      // {
      //   label: "tnc",
      //   // type: "number",
      //   controllerName: "tnc",
      //   required: true,
      //   hide: false,
      //   valueType: 'tnc',
      //   placeholder: "tnc",
      //   errorMsg: 'terms and conditions',
      // },
    ]
  ];

  constructor(public dialog: MatDialog, private authService: AuthService) {
  }

  ngOnInit(): void {
    this.valueAssign()
    // this.openDialog()
  }

  valueAssign() {

  }

  // openDialog() {
  //   const dialogRef = this.dialog.open(RegistrationDialogComponent, {
  //     width: '500px',
  //     // height: '500px',
  //     // backdropfilter: 'blur(4px)',
  //   });

  //   // dialogRef.afterClosed().subscribe((result) => {

  //   // });
  // }

  // createAccount() {
  //   this.openDialog()
  // }

  openDialog() {
    const dialogRef = this.dialog.open(RegistrationDialogComponent, {
      width: '500px',
      // backdropClass: 'backdropBackground',
    });
  }

  submitData(response) {
    // console.log(response);
    let registerData = {
      facility_name: response[0].value.facility_name,
      email: response[0].value.email,
      mobile: response[0].value.mobile,
      hospital_reg_num: response[0].value.hospital_reg_num,
      otp: response[0].value.otp,
      otpTxnId: response[1].otpTxnId,
    }

    console.log('in submit data', registerData);

    this.authService.registerSubmit(registerData).subscribe((response: any) => {
      console.log("OTP DATA", response);
      sessionStorage.setItem("registered number", registerData.mobile)
      // if (response.code == 200) {
      this.openDialog()
      // }
    },
      (error) => {
        console.log(error.error.message);
        Swal.fire('Error', `${error.error.message}`, 'error')
      }
    )
  }

  formButtonResEvent(response) {
    console.log("inside reg form", response);
    if (response[0].status == 'VALID') {
      // Swal.fire('Sucess', 'Form DATA is VALID', 'success')
      this.submitData(response)
      console.log(response);
    }
  }
}
